/* eslint-disable max-len */
import {defineMessages} from 'react-intl';

export default defineMessages({
	greeting: {
		id: 'popup.countryRedirectPopup.greeting',
		defaultMessage: 'Hello,'
	},
	heading: {
		id: 'popups.countryRedirect.heading',
		defaultMessage: 'You are currently browsing on our website for {currentCountry}. Would you like to keep this selection?'
	},
	yesButton: {
		id: 'popups.countryRedirect.yesButton.text',
		defaultMessage: 'Yes, continue on {currentCountry}'
	},
	noButton: {
		id: 'popups.countryRedirect.noButton.text',
		defaultMessage: 'No, switch to {userCountry}'
	},
	seeMoreButton: {
		id: 'popups.countryRedirect.seeMoreButton.text',
		defaultMessage: 'See more countries'
	},
	selectCountry: {
		id: 'popups.countryRedirect.selectCountry.text',
		defaultMessage: 'Select your country'
	},
});
